// extracted by mini-css-extract-plugin
export default {"button-wrapper":"OAuthLoginButton_button-wrapper__9k4YB","error-message":"OAuthLoginButton_error-message__deCG0"};